import { useFormContext } from 'react-hook-form'
import { TextField } from '@boltenergy-be/design-system'
import { getFieldError, getFieldName } from 'components/inputs/utils'
import { MeterNumberProps } from 'components/inputs/meter-number/types'
import { useTranslation } from 'next-i18next/pages'
import { isValidEAN } from 'utils/helpers'

const MeterNumber = ({ parentDotPath }: MeterNumberProps) => {
  // React Hook Form
  const {
    formState: { errors },
    register
  } = useFormContext()

  // i18n
  const { t } = useTranslation(['commonFormFields', 'validation'])

  return (
    <TextField
      {...register(getFieldName('meterNumber', parentDotPath), {
        maxLength: {
          value: 18,
          message: t(($) => $.max.string, {
            attribute: t(($) => $.meterNumber.label),
            length: 18,
            ns: 'validation'
          })
        },
        required: t(($) => $.required, { ns: 'validation' }),
        validate: (value: number) => !isValidEAN(value.toString(10)) || t(($) => $.meterReading.errors.looksLikeEan)
      })}
      error={getFieldError('meterNumber', parentDotPath, errors)?.message}
      label={t(($) => $.meterNumber.label)}
      type="text"
    />
  )
}

export default MeterNumber
